var $7578e57e0bfd56a1$exports = {};
$7578e57e0bfd56a1$exports = {
    "loading": `Indl\xe6ser ...`,
    "placeholder": `V\xe6lg\u{2026}`
};


export {$7578e57e0bfd56a1$exports as default};
//# sourceMappingURL=da-DK.mjs.map
